import { type } from "../types/types";

export const set_logout = (logout) => (dispatch) => {
  dispatch({
    type: type.LOGOUT,
    logout: logout,
  });
};
